module.exports = __webpack_public_path__ + "img/UF_gate.3497057b.jpg";